export default __webpack_public_path__ + "static/media/products.161ea94c.xlsx";